import { render, staticRenderFns } from "./InventoryScan.vue?vue&type=template&id=5d755aee&scoped=true&"
import script from "./InventoryScan.vue?vue&type=script&lang=js&"
export * from "./InventoryScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d755aee",
  null
  
)

export default component.exports